import DailyTasks from './DailyTasks'

export default DailyTasks
